import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Book, Download, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const PrayerGuide: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const pdfUrl = "https://fra1.digitaloceanspaces.com/islamnu/archive/ebook/file/B%C3%B6nebok_2024_webb1.pdf";
  const [isLoading, setIsLoading] = useState(true);
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    // Detect mobile devices
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /iphone|ipad|ipod|android|mobile/.test(userAgent);
    setIsMobileDevice(isMobile);
  }, []);

  const handlePdfLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="container mx-auto p-4">
      <div className="flex justify-between items-center mb-6">
        <button 
          onClick={() => navigate(-1)}
          className="flex items-center text-purple-600 hover:text-purple-800 transition-colors"
        >
          <ArrowLeft className="h-5 w-5 mr-1" />
          <span>{t('back')}</span>
        </button>
        <h1 className="text-2xl font-bold text-center flex-grow">{t('prayerGuide')}</h1>
        <div className="w-20"></div> {/* Spacer for alignment */}
      </div>
      
      {/* PDF Viewer */}
      <div className="relative bg-gray-100 dark:bg-gray-700 rounded-lg shadow-lg p-4 mb-4">
        {isMobileDevice ? (
          // Mobile specific implementation with direct link
          <div className="p-4 text-center">
            <p className="text-gray-600 dark:text-gray-300 mb-6">
              {t('iosPdfMessage')}
            </p>
            <a 
              href={pdfUrl}
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-colors duration-300"
            >
              <Book className="h-5 w-5 mr-2" />
              {t('openPdf')}
            </a>
          </div>
        ) : (
          // Desktop implementation with iframe
          <div className="w-full h-[80vh] overflow-hidden">
            {isLoading && (
              <div className="absolute inset-0 flex items-center justify-center bg-gray-200 dark:bg-gray-800 bg-opacity-70 dark:bg-opacity-70 rounded-lg">
                <div className="flex flex-col items-center space-y-2">
                  <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-600"></div>
                  <p>{t('loading')}</p>
                </div>
              </div>
            )}
            <div className="w-full h-full overflow-auto -webkit-overflow-scrolling-touch">
              <iframe 
                src={`${pdfUrl}#view=FitH&toolbar=1&navpanes=1`}
                className="w-full h-full rounded-lg border-2 border-gray-300 dark:border-gray-600"
                onLoad={handlePdfLoad}
                title="Prayer Guide PDF"
                style={{overflow: 'auto', width: '100%', height: '100%'}}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrayerGuide;